import styled from "styled-components";
import { useState } from "react";
import VehicleSelect from "./VehicleSelect";
import ClickAwayListener from "@mui/material/ClickAwayListener";

//----------------------------------------------------------------

const SelectBox = styled.div<{
  isDropdownOpen: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 5px;
  height: 100%;
  color: #1a7cdb;
  top: 0;
  user-select: none;
  cursor: pointer;
  font-size: 11px;

  .fa-angle-down {
    transform: ${({ isDropdownOpen }) =>
      isDropdownOpen ? "rotateX(180deg)" : "rotateX(0deg)"};
    transition: transform 0.3s ease-in-out, color 0.3s ease-in-out;
    font-size: 10px;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
`;

//------------------------------------------------------------------------

interface StaffSelectProps {
  vehicle_ids: string[];
  setVehicle_ids: (user_ids: string[]) => void;
}

const VehicleSelectDropdown = ({
  vehicle_ids,
  setVehicle_ids,
}: StaffSelectProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleClickAway = () => {
    setIsDropdownOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className="cell sticky-col sticky-row top-left">
        <SelectBox
          id="select-name"
          isDropdownOpen={isDropdownOpen}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span>Select vehicles</span>
          <i className="fas fa-angle-down"></i>
        </SelectBox>

        {isDropdownOpen && (
          <Dropdown>
            <VehicleSelect
              vehicle_ids={vehicle_ids}
              setVehicle_ids={setVehicle_ids}
            />
          </Dropdown>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default VehicleSelectDropdown;
